<template>
  <router-view></router-view>
  <SignupBar v-if="route.name !== 'Support'" />
</template>

<script setup>
import { useRoute } from 'vue-router'
import SignupBar from '@/components/uielements/SignupBar.vue'

const route = useRoute()
</script>
